import 'owl.carousel';
import lozad from 'lozad'

export const initOwlCarouselProjectImages = () => {
    $(".owl-carousel-project-images").owlCarousel({
        loop:false,
        autoplay:false,
        margin:0,
        nav: false,
        dots: true,
        smartSpeed:450,
        autoHeight:true,
        items:1
    });
};
